export default "__VITE_ASSET__962ddbc5__"